import HomePage from '~psp-pages/lufthansa/home/home.vue'
import RedemptionPage from '~psp-pages/lufthansa/redemption/redemption.vue'
import Payment from '~psp-pages/lufthansa/redemption/payment.vue'
import Summary from '~psp-pages/lufthansa/redemption/summary.vue'

import routerBuilder from './routerBuilder'

const router = routerBuilder({
  HomePage, RedemptionPage, Summary, Payment,
})

export default router
